/**
 * @fileoverview Barrel exports for the draft-all-chapters COMPOSITE agent.
 *
 * This is a composite agent that sequentially drafts all planned chapters.
 * Unlike most composites, it runs client-side (not via Genkit flow) because
 * it needs to refresh project state between chapters.
 *
 * Structure:
 * - definition.ts: Agent metadata with composite configuration
 * - schema.ts: Input/output/progress Zod schemas
 * - prompt.ts: Placeholder prompt (primitives have their own prompts)
 * - flow.ts: Stub (orchestration is in the hook)
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  HookInputSchema,
  OutputSchema,
  ChapterResultSchema,
  ProgressStateSchema,
  type HookInput,
  type Output,
  type ChapterResult,
  type ProgressState,
} from './schema';

// Flow (stub - throws if called)
export { flow } from './flow';

